var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebookAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_21173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.7852C24 6.15778 18.6274 0.785156 12 0.785156C5.37262 0.785156 0 6.15769 0 12.7852C0 18.7747 4.38825 23.7392 10.125 24.6394V16.2539H7.07812V12.7852H10.125V10.1414C10.125 7.13391 11.9166 5.47266 14.6575 5.47266C15.9705 5.47266 17.3438 5.70703 17.3438 5.70703V8.66016H15.8306C14.3398 8.66016 13.875 9.58519 13.875 10.5342V12.7852H17.2031L16.6711 16.2539H13.875V24.6394C19.6117 23.7392 24 18.7747 24 12.7852Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6711 16.2539L17.2031 12.7852H13.875V10.5342C13.875 9.58509 14.3399 8.66016 15.8306 8.66016H17.3438V5.70703C17.3438 5.70703 15.9705 5.47266 14.6575 5.47266C11.9166 5.47266 10.125 7.13391 10.125 10.1414V12.7852H7.07812V16.2539H10.125V24.6394C10.7453 24.7366 11.3722 24.7853 12 24.7852C12.6278 24.7853 13.2547 24.7366 13.875 24.6394V16.2539H16.6711Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_21173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.785156)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookAuth);
export default __webpack_public_path__ + "static/media/facebook-auth.a1a109fce6d16270e120b809bbc1831f.svg";
export { ForwardRef as ReactComponent };